import EventAttribute from '../../event-attribute';
import constants from './constants';
import glossary from './glossary';

export default class AssociationAttribute extends EventAttribute {
  constructor(item = {}, url) {
    super(item, url);
    this.association_id = item.association_id;
  }

  currentAssign(associationId) {
    return this.assign.find(({ event_association_id }) => event_association_id === associationId);
  }

  isAssignRequired(associationId) {
    return !!this.currentAssign(associationId)?.options?.required;
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
